/* tslint:disable */
/* eslint-disable */
/**
 * GlassHouse.Dashboard.Api | v1
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { ActorActivityRecordActorUserId } from './ActorActivityRecordActorUserId';
import {
    ActorActivityRecordActorUserIdFromJSON,
    ActorActivityRecordActorUserIdFromJSONTyped,
    ActorActivityRecordActorUserIdToJSON,
    ActorActivityRecordActorUserIdToJSONTyped,
} from './ActorActivityRecordActorUserId';
import type { StatementDisplayStatus } from './StatementDisplayStatus';
import {
    StatementDisplayStatusFromJSON,
    StatementDisplayStatusFromJSONTyped,
    StatementDisplayStatusToJSON,
    StatementDisplayStatusToJSONTyped,
} from './StatementDisplayStatus';
import type { StatementPeriod } from './StatementPeriod';
import {
    StatementPeriodFromJSON,
    StatementPeriodFromJSONTyped,
    StatementPeriodToJSON,
    StatementPeriodToJSONTyped,
} from './StatementPeriod';

/**
 * 
 * @export
 * @interface GetBalanceStatementByUserRequest
 */
export interface GetBalanceStatementByUserRequest {
    /**
     * 
     * @type {ActorActivityRecordActorUserId}
     * @memberof GetBalanceStatementByUserRequest
     */
    userId?: ActorActivityRecordActorUserId | null;
    /**
     * 
     * @type {any}
     * @memberof GetBalanceStatementByUserRequest
     */
    from?: any | null;
    /**
     * 
     * @type {any}
     * @memberof GetBalanceStatementByUserRequest
     */
    to?: any | null;
    /**
     * 
     * @type {StatementDisplayStatus}
     * @memberof GetBalanceStatementByUserRequest
     */
    displayStatus?: StatementDisplayStatus | null;
    /**
     * 
     * @type {string}
     * @memberof GetBalanceStatementByUserRequest
     */
    descriptionSearch?: string | null;
    /**
     * 
     * @type {string}
     * @memberof GetBalanceStatementByUserRequest
     */
    transactionCode?: string | null;
    /**
     * 
     * @type {StatementPeriod}
     * @memberof GetBalanceStatementByUserRequest
     */
    period?: StatementPeriod | null;
}



/**
 * Check if a given object implements the GetBalanceStatementByUserRequest interface.
 */
export function instanceOfGetBalanceStatementByUserRequest(value: object): value is GetBalanceStatementByUserRequest {
    return true;
}

export function GetBalanceStatementByUserRequestFromJSON(json: any): GetBalanceStatementByUserRequest {
    return GetBalanceStatementByUserRequestFromJSONTyped(json, false);
}

export function GetBalanceStatementByUserRequestFromJSONTyped(json: any, ignoreDiscriminator: boolean): GetBalanceStatementByUserRequest {
    if (json == null) {
        return json;
    }
    return {
        
        'userId': json['userId'] == null ? undefined : ActorActivityRecordActorUserIdFromJSON(json['userId']),
        'from': json['from'] == null ? undefined : json['from'],
        'to': json['to'] == null ? undefined : json['to'],
        'displayStatus': json['displayStatus'] == null ? undefined : StatementDisplayStatusFromJSON(json['displayStatus']),
        'descriptionSearch': json['descriptionSearch'] == null ? undefined : json['descriptionSearch'],
        'transactionCode': json['transactionCode'] == null ? undefined : json['transactionCode'],
        'period': json['period'] == null ? undefined : StatementPeriodFromJSON(json['period']),
    };
}

export function GetBalanceStatementByUserRequestToJSON(json: any): GetBalanceStatementByUserRequest {
    return GetBalanceStatementByUserRequestToJSONTyped(json, false);
}

export function GetBalanceStatementByUserRequestToJSONTyped(value?: GetBalanceStatementByUserRequest | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'userId': ActorActivityRecordActorUserIdToJSON(value['userId']),
        'from': value['from'],
        'to': value['to'],
        'displayStatus': StatementDisplayStatusToJSON(value['displayStatus']),
        'descriptionSearch': value['descriptionSearch'],
        'transactionCode': value['transactionCode'],
        'period': StatementPeriodToJSON(value['period']),
    };
}

